<!--suppress HtmlFormInputWithoutLabel -->
<template>
  <div class="user-new-profile">
    <div class="profile-wrapper">
      <section class="user-info card">
        <div class="input-wrapper row">
          <dropdown-select
            v-model="gender"
            :label="$t('profile.gender')"
            :options="genderOptions"
            :placeholder="$t('Select')"
            @input="onGenderChange" />
          <input v-if="genderIsOther"
                 ref="genderOtherInput"
                 v-model="genderOtherName">
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import DropdownSelect from '../components/UI/DropdownSelect'

export default {
  name: 'UserNewProfile',
  components: { DropdownSelect },

  data: () => ({
    genderOptions: {
      male: this.$t('gender.male'),
      female: this.$t('gender.female'),
      other: this.$t('gender.other')
    }
  }),

  computed: {
    genderOtherName: {
      get () {
        return this.profile.genderOtherName || ''
      },
      set (value) {
        this.set({ name: 'genderOtherName', value })
      }
    }
  },

  methods: {
    ...mapMutations('profile', ['set']),

    onGenderChange (gender) {
      if (gender === 'other') {
        this.$nextTick(() => { this.$refs.genderOtherInput.focus() })
      }
    }
  }
}
</script>

<style lang="scss">
  .user-new-profile {
  }
</style>
